import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lastComm"]

  connect() {
    // Encontrar o elemento com data-last-update-minutes
    this.lastCommElement = this.element.querySelector('[data-last-update-minutes]')
    
    if (this.lastCommElement) {
      this.lastUpdateMinutes = parseInt(this.lastCommElement.dataset.lastUpdateMinutes) || 0
      this.lastUpdateTimestamp = this.lastCommElement.dataset.lastUpdateTimestamp
      
      // Calcular o timestamp real da última comunicação do rastreador
      this.calculateActualLastCommunicationTime()
      
      // Iniciar timer para atualizar a cada 10 segundos
      this.startTimer()
      
      // Atualizar imediatamente
      this.updateTimeDisplay()
    }
  }

  calculateActualLastCommunicationTime() {
    // Se temos lastUpdateMinutes (tempo desde a última comunicação em minutos)
    if (this.lastUpdateMinutes > 0) {
      // Calcular quando foi a última comunicação real do rastreador
      this.lastTrackerCommunication = new Date(Date.now() - (this.lastUpdateMinutes * 60 * 1000))
    } else {
      // Se é 0 ou não definido, significa que é recente (agora)
      this.lastTrackerCommunication = new Date()
    }
  }

  disconnect() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
      this.timerInterval = null
    }
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
      this.updateTimeDisplay()
    }, 10000) // Atualizar a cada 10 segundos
  }

  updateTimeDisplay() {
    if (!this.lastCommElement || !this.lastTrackerCommunication) return

    const now = new Date()
    const diffMs = now - this.lastTrackerCommunication
    const diffSeconds = Math.floor(diffMs / 1000)
    const diffMinutes = Math.floor(diffSeconds / 60)
    const diffHours = Math.floor(diffMinutes / 60)
    const diffDays = Math.floor(diffHours / 24)
    
    let timeText
    
    if (diffMinutes < 1) {
      // Qualquer coisa menor que 1 minuto = "agora"
      timeText = 'agora'
    } else if (diffMinutes < 60) {
      // há 1min, há 2min, há 3min, etc.
      timeText = `há ${diffMinutes}min atrás`
    } else if (diffHours < 24) {
      // há 1h, há 2h, há 3h, etc.
      timeText = `há ${diffHours}h atrás`
    } else if (diffDays === 1) {
      timeText = 'ontem'
    } else if (diffDays < 30) {
      // há 2 dias, há 3 dias, etc.
      timeText = `há ${diffDays} dias atrás`
    } else if (diffDays < 365) {
      // há 1 mês, há 2 meses, etc.
      const months = Math.floor(diffDays / 30)
      timeText = `há ${months} ${months === 1 ? 'mês' : 'meses'} atrás`
    } else {
      // há 1 ano, há 2 anos, etc.
      const years = Math.floor(diffDays / 365)
      timeText = `há ${years} ${years === 1 ? 'ano' : 'anos'} atrás`
    }
    
    
    this.lastCommElement.textContent = timeText
  }

  // Método para atualizar quando houver nova comunicação do rastreador
  updateTrackerCommunication(newLastUpdateMinutes) {

    this.lastUpdateMinutes = newLastUpdateMinutes
    this.lastCommElement.dataset.lastUpdateMinutes = this.lastUpdateMinutes

    // Recalcular o timestamp da última comunicação real do rastreador
    this.calculateActualLastCommunicationTime()

    // Atualizar display imediatamente
    this.updateTimeDisplay()
  }

  // Para o timer quando não há dado de última comunicação (veículo nunca
  // comunicou) -- o texto "Sem dados" já foi escrito pelo chamador e não deve
  // ser sobrescrito por um cálculo de tempo decorrido.
  stopTracking() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
      this.timerInterval = null
    }
    delete this.lastCommElement.dataset.lastUpdateMinutes
    this.lastTrackerCommunication = null
  }
}